import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PATHS } from '@/config/paths';

export function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex h-screen items-center justify-center bg-[var(--bg-primary)]">
      <Result
        status="404"
        title="404"
        subTitle={t('errors.notFoundSubtitle')}
        extra={
          <Button type="primary" onClick={() => navigate(PATHS.HOME)}>
            {t('errors.backHome')}
          </Button>
        }
      />
    </div>
  );
}
